export default __webpack_public_path__ + "static/media/66.4bd95b84.png";